import { Outlet } from "react-router-dom";
import AccessDeniedError from "../components/pages/AccessDeniedError";

interface ICustomAdminroute {
  isAdmin: boolean;
}

const CustomAdminRoute = (props: ICustomAdminroute) => {
  return props.isAdmin ? (
    <Outlet data-testid="childRoute" />
  ) : (
    <AccessDeniedError />
  );
};

export default CustomAdminRoute;
